<template>
    <div >
        <div v-if="typeof input[component.name] !== 'undefined' && component.name === 'presentToInvestors'" class="pd-10 th w-80 has-text-left">
            <p class="has-text-weight-normal">หากสนใจเราจะขออนุญาตเปิดเผยข้อมูลธุรกิจของคุณให้แก่นักลงทุนโดยคุณจะต้องกรอกข้อมูลต่อไปนี้</p>
            <p class="des-dynamic">(If you would like to present your business to investors, your business information will be sent to the investor. So please fill up the form by these following)</p>
            <p class="has-text-weight-normal">หากสนใจเราจะขออนุญาตเปิดเผยข้อมูลธุรกิจของคุณให้แก่นักลงทุนโดยคุณจะต้องกรอกข้อมูลต่อไปนี้ อันได้แก่</p>
            <p class="has-text-weight-normal">1. ข้อมูลธุรกิจเบื้องต้นและช่องทางติดต่อคุณ</p>
            <p class="des-dynamic">(Basic business information and contact information.)</p>
            <p class="has-text-weight-normal">2. ผลการดำเนินงานในโครงการต่าง ๆ แบบสรุปผล</p>     
            <p class="des-dynamic">(Your business performance when you are in the incubator/accelerator or any activity.)</p>            
            <p class="has-text-weight-normal">3. ความคิดเห็นจากบุคลลที่ 3 เกี่ยวกับธุรกิจของคุณอาทิ Mentor หรือนักลงทุน รายอื่น ๆ ข้อมูลทั้งหมด (ระบบของเราไม่ได้คิดค่าบริการใด ๆ จากท่าน)</p>    
            <p class="des-dynamic">(Review of your business information from third party (i.e. Mentor or Investor))</p>            
        </div>
        <div v-if="component.type === 'text' && component.options.hidden === false && checkMathId(component.display.matchid,matchId)" class="pd-10 has-text-left w-80">
            <div class="pd-y-4">
                <p v-if="!component.options.hideLabel && component.display.label !== ''" class="is-size-6 th is-flex ai-center">{{component.display.label}} <span v-if="component.validation.required" class="has-text-danger">*</span>
                    <b-tooltip  v-if="component.options.toolTip !== ''" :label="component.options.toolTip" size="is-small" class="mg-l-5" type="is-dark">
                        <b-icon pack="fas" size="is-small" icon="question-circle" class="has-text-grey-light"></b-icon>
                    </b-tooltip>
                </p>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            <div class="has-text-right">
                <div v-if="typeof dataInputKpi[component.name] !== 'undefined' && typeof component.options !== 'undefined' && typeof component.options.repeat !== 'undefined' && component.options.repeat === true">
                    <p class="th" v-if="dataInputKpi[component.name].input !== ''"><span class="has-text-weight-normal">ข้อมูลล่าสุด: </span><span>{{dataInputKpi[component.name].input}}</span><span v-if="dataInputKpi[component.name].lastUpdate !== null"> เมื่อ {{dataInputKpi[component.name].lastUpdate  | dateFomatShortmonth}}</span></p>
                </div>
                <b-field 
                    label="" 
                    :message="valid[component.name].valid === true?component.validation.errorMsg:''" 
                    :type="valid[component.name].valid === true?'is-danger':''"
                    class="has-text-right"
                >
                    <b-input 
                        :placeholder="component.display.placeholder"
                        :type="(component.display.password)?'password':''"
                        icon-pack="fas"
                        :icon="(component.options.leftIcon)?component.options.leftTypeIcon:''"
                        :name="'input'+componentsIndex+componentDataIndex+component.name"
                        :minlength="component.validation.min"
                        :maxlength="component.validation.max"
                        :readonly="component.options.readOnly"
                        v-model="input[component.name]"
                        @input="checkValidate(component.name,component.validation)"
                        :customClass="component.options.customClass"
                    ></b-input>
                </b-field>
            </div>
 
            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <b-field 
                        label="" 
                        class="width-max is-marginless"
                        :message="valid[inputItem.name].valid === true?inputItem.validation.errorMsg:''" 
                        :type="valid[inputItem.name].valid === true?'is-danger':''"
                    >
                        <b-input 
                            :placeholder="inputItem.display.placeholder"
                            :type="(inputItem.display.password)?'password':''"
                            icon-pack="fas"
                            :icon="(inputItem.options.leftIcon)?inputItem.options.leftTypeIcon:''"
                            :minlength="inputItem.validation.min"
                            :maxlength="inputItem.validation.max"
                            :readonly="inputItem.options.readOnly"
                            v-model="input[inputItem.name]"
                            @input="checkValidate(inputItem.name,inputItem.validation)"
                            :customClass="inputItem.options.customClass"
                        ></b-input>
                    </b-field>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>
            <div class="pd-y-5" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined">Add input</a>
            </div>
        </div>
        <div v-if="component.type === 'textarea' && checkMathId(component.display.matchid,matchId)" class="pd-10 has-text-left w-80">
            <div class=" pd-y-4">
                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p><span v-if="component.validation.required" class="has-text-danger">*</span>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            
            <div>
                <b-field 
                    label="" 
                    class="position-unset"
                    :message="valid[component.name].valid === true?component.validation.errorMsg:''" 
                    :type="valid[component.name].valid === true?'is-danger':''"
                >
                    <b-input type="textarea"
                        :minlength="component.validation.min"
                        :maxlength="component.validation.max"
                        v-model="input[component.name]"
                        :name="'input'+componentsIndex+componentDataIndex+component.name"
                        @input="checkValidate(component.name,component.validation)"
                        :placeholder="component.display.placeholder">
                    </b-input>
                </b-field>
            </div>

            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <b-field 
                        label="" 
                        class="width-max  position-unset"
                        :message="valid[inputItem.name].valid === true?inputItem.validation.errorMsg:''" 
                        :type="valid[inputItem.name].valid === true?'is-danger':''"
                    >
                        <b-input type="textarea"
                            :minlength="inputItem.validation.min"
                            :maxlength="inputItem.validation.max"
                            v-model="input[inputItem.name]"
                            @input="checkValidate(inputItem.name,inputItem.validation)"
                            :placeholder="inputItem.display.placeholder">
                        </b-input>
                    </b-field>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>
            <div class="pd-y-4" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined">Add input</a>
            </div>
        </div>
        <div v-if="component.type === 'select' && checkMathId(component.display.matchid,matchId)" class="pd-10 has-text-left w-80">
            <div class="pd-y-4">
                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p><span v-if="component.validation.required" class="has-text-danger">*</span>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            <div>
                <div v-if="component.display.choice === 'phoneNumber'" >
                    <VuePhoneNumberInput 
                        v-model="phoneNumber" 
                        @update="updateNumberPhone"
                        no-validator-state
                        :class="{'error':valid[component.name].valid === true}"
                        :default-country-code="(input[component.name] !== null && typeof input[component.name].countryCode !== 'undefineted')?input[component.name].countryCode:''"
                    />
                    <div class="has-text-right">
                        <p class="th is-size-7 mg-t-5"  :class="{'has-text-danger':valid[component.name].valid === true}">{{valid[component.name].valid === true?component.validation.errorMsg:''}}</p>
                    </div>
                </div>
                <b-field 
                    v-else
                    label="" 
                    :message="(valid[component.name].valid === true)?component.validation.errorMsg:''" 
                    :type="(valid[component.name].valid === true)?'is-danger':''"
                >
                    <b-select 
                        v-model="input[component.name]"
                        :placeholder="component.display.placeholder" 
                        @input="checkValidateRequired(component.name,component.validation.required)"
                        expanded
                    >
                        <option v-for="(select,index) in getSelectValue(component.display.choice,component.display.value)" :key="index" :value="select">{{select.label}}</option>
                    </b-select>
                </b-field>
            </div>
            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <b-field 
                        label="" 
                        class="width-max"
                        :message="(valid[inputItem.name].valid === true)?inputItem.validation.errorMsg:''" 
                        :type="(valid[inputItem.name].valid === true)?'is-danger':''"
                    >
                        <b-select 
                            v-model="input[inputItem.name]"
                            :placeholder="inputItem.display.placeholder" 
                            @input="checkValidateRequired(inputItem.name,inputItem.validation.required)"
                            expanded
                        >
                            <option v-for="(select,index) in getSelectValue(inputItem.display.choice,inputItem.display.value)" :key="index" :value="select">{{select.label}}</option>
                        </b-select>
                    </b-field>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>
            <div class="pd-y-5" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined">Add input</a>
            </div>
        </div>
        <div  v-if="component.type === 'file' && checkMathId(component.display.matchid,matchId)"  class="pd-10 has-text-left w-80">
            <div class="has-text-left pd-y-4">
                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p><span v-if="component.validation.required" class="has-text-danger">*</span>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            <div>
                <FieldUpload  
                    v-if="component.type === 'file' && checkMathId(component.display.matchid,matchId)" 
                    :component="component" 
                    :input="input"
                    :valid="valid"
                    :delFile="delFile"
                    :addInput="addInput"
                    :delInput="delInput"
                    :inputFormData="inputFormData"
                    :components="components"
                    :value="input[component.name]"
                    :ownedId="ownedId"
                    @checkValidateRequired="checkValidateRequired"
                />
            </div>
            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <div  class="width-max pd-y-5">
                        <FieldUpload  
                            v-if="component.type === 'file' && checkMathId(component.display.matchid,matchId)" 
                            :component="inputItem" 
                            :input="input"
                            :valid="valid"
                            :delFile="delFile"
                            :addInput="addInput"
                            :delInput="delInput"
                            :inputFormData="inputFormData"
                            :components="components"
                            :value="input[component.name]"
                            :formUserId="formUserId"
                            :ownedId="ownedId"
                            @checkValidateRequired="checkValidateRequired"
                        />
                    </div>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>
            <div class="pd-y-5" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined">Add input</a>
            </div>
        </div>
        <div v-if="component.type === 'date' && checkMathId(component.display.matchid,matchId)" class="pd-10 has-text-left w-80">
            <div class="has-text-left pd-y-4">
                <p v-if="component.display.label !== ''" class="is-size-6 th">{{component.display.label}}</p><span v-if="component.validation.required" class="has-text-danger">*</span>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            <div>
                <date-picker  
                    @input="checkValidateRequired(component.name,component.validation)"
                    :type="component.options.type" 
                    :lang="'en'" 
                    v-model="input[component.name]"
                    :range="component.options.range" 
                    :format="component.options.format" 
                    :first-day-of-week="component.options.datePicker.firstDayOfWeek" 
                    :not-before="component.options.datePicker.notBefore" 
                    :not-after="component.options.datePicker.notAfter" 
                    :default-value="component.options.datePicker.defaultDate"
                    
                />
                <p class="th is-size-7 mg-t-5" 
                    :class="{'has-text-danger':valid[component.name].valid === true}"
                    v-if="valid[component.name].valid === true"
                >{{component.validation.errorMsg}}</p>
            </div>
            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <div class="width-max ">
                        <date-picker  
                            @input="checkValidateRequired(inputItem.name,inputItem.validation)"
                            :type="inputItem.options.type" 
                            :lang="'en'" 
                            v-model="input[inputItem.name]"
                            :range="inputItem.options.range" 
                            :format="inputItem.options.format" 
                            :first-day-of-week="inputItem.options.datePicker.firstDayOfWeek" 
                            :not-before="inputItem.options.datePicker.notBefore" 
                            :not-after="inputItem.options.datePicker.notAfter" 
                            :default-value="inputItem.options.datePicker.defaultDate"
                            
                        />
                        <p class="th is-size-7 mg-t-5" 
                            :class="{'has-text-danger':valid[inputItem.name].valid === true}"
                            v-if="valid[inputItem.name].valid === true"
                        >{{inputItem.validation.errorMsg}}</p>
                    </div>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>
            <div class="pd-y-5" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined">Add input</a>
            </div>
        </div>
        <div v-if="component.type === 'radio' && checkMathId(component.display.matchid,matchId)" class="pd-10 has-text-left">
            <div class="pd-y-4"> 
                <p  class="is-size-6 th has-text-weight-normal" v-if="component.display.label !== ''">{{component.display.label}}</p><span v-if="component.validation.required" class="has-text-danger">*</span>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            <div>
                <div v-for="(value,index) in component.display.value" :key="index" class="field" >
                    <div class="is-flex ai-center">
                        <b-radio 
                            v-model="input[component.name]['data']"  
                            @input="checkValidateRequiredObject(component.name,component.validation.required),setMatchId(component.display.value,value,components,'radio'),setTourForm()"
                            @click.native="(input[component.name].data !== null && value.label !== input[component.name].data.label)?clearRadio(input[component.name],component.name,component.display.value):input[component.name].des = input[component.name].des"
                            :name="'input'+componentsIndex+componentDataIndex+component.name"
                            :native-value="{label:value.label,value:value.value,userValue:value.userValue,index:index}"
                            type="is-dark"
                        >
                            <p class="th">{{value.label}}</p>
                        </b-radio>
                        <b-field 
                            v-if="value.userValue === true" 
                            :message="valid[component.name+'UserValue'+index].valid === true?'กรุณากรอกข้อความ':''" 
                            :type="valid[component.name+'UserValue'+index].valid === true?'is-danger':''"
                            class="mg-l-2 mw-500 fixed-error-msg"
                        >
                            <b-input 
                                expanded
                                v-if="input[component.name].data !== null && value.label === input[component.name].data.label"
                                placeholder="โปรดระบุ"
                                icon-pack="fas"
                                v-model="input[component.name].des" 
                                @keyup.native="checkValidateRequiredDes(component.name,component.name+'UserValue'+index, true)"
                            >
                            </b-input>
                        </b-field>
                    </div>
                </div>
                <p class="th is-size-7 mg-t-5 th"  :class="{'has-text-danger':valid[component.name].valid === true}">
                    {{valid[component.name].valid === true?component.validation.errorMsg:''}}
                </p>
            </div>
            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <div>
                        <div v-for="(value,index) in inputItem.display.value" :key="index" class="field" >
                            <div class="is-flex ai-center">
                                <b-radio 
                                    v-model="input[inputItem.name]['data']"  
                                    @input="checkValidateRequiredObject(inputItem.name,inputItem.validation.required),setMatchId(inputItem.display.value,value,components,'radio'),setTourForm()"
                                    @click.native="(input[inputItem.name].data !== null && value.label !== input[inputItem.name].data.label)?clearRadio(input[inputItem.name],inputItem.name,inputItem.display.value):input[inputItem.name].des = input[inputItem.name].des"
                                    :native-value="{label:value.label,value:value.value,userValue:value.userValue,index:index}"
                                    type="is-dark"
                                >
                                    <p class="th">{{value.label}}</p>
                                </b-radio>
                                <b-field 
                                    v-if="value.userValue === true" 
                                    :message="valid[inputItem.name+'UserValue'+index].valid === true?'กรุณากรอกข้อความ':''" 
                                    :type="valid[inputItem.name+'UserValue'+index].valid === true?'is-danger':''"
                                    class="mg-l-2 mw-500 fixed-error-msg"
                                >
                                    <b-input 
                                        expanded
                                        v-if="input[inputItem.name].data !== null && value.label === input[inputItem.name].data.label"
                                        placeholder="โปรดระบุ"
                                        icon-pack="fas"
                                        v-model="input[inputItem.name].des" 
                                        @keyup.native="checkValidateRequiredDes(inputItem.name,inputItem.name+'UserValue'+index, true)"
                                    >
                                    </b-input>
                                </b-field>
                            </div>
                        </div>
                        <p class="th is-size-7 mg-t-5 th"  :class="{'has-text-danger':valid[inputItem.name].valid === true}">
                            {{valid[inputItem.name].valid === true?inputItem.validation.errorMsg:''}}
                        </p>
                    </div>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>

            <div class="pd-y-5" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined">Add input</a>
            </div>
        </div>
        

        <div v-if="component.type === 'checkbox' && checkMathId(component.display.matchid,matchId)" class="pd-10 has-text-left">
            <div class="has-text-left pd-y-4">
                <p  class="is-size-6 th has-text-weight-normal" v-if="component.display.label !== ''">{{component.display.label}}</p><span v-if="component.validation.required" class="has-text-danger">*</span>
                <p class="is-size-6 des-dynamic th">
                    {{component.display.description}}
                </p>
            </div>
            <div >
                <div  v-for="(value,index) in component.display.value" :key="index" class="field">
                    <div class="is-flex ai-center">
                        <b-checkbox 
                            v-model="checkModelValue[component.name]"
                            @change.native="setDataCheckBox(value.label,component.name,index,component.name+'UserValue'+index)"
                            @input="checkValidateRequiredCheckBox(component.name,component.validation.required),setMatchId(checkModelValue[component.name],value,components,'checkbox'),setTourForm()"
                            :name="'input'+componentsIndex+componentDataIndex+component.name"
                            :native-value="{label:value.label,value:value.value,userValue:value.userValue,index:index}"
                            type="is-dark"
                        >
                            <p class="th">{{value.label}}</p>
                        </b-checkbox>
                        <b-field 
                            v-if="value.userValue === true && checkModelValue[component.name].length !== 0 && checkValueCheckBox(value.label,checkModelValue[component.name]) === true" 
                            :message="valid[component.name+'UserValue'+index].valid === true?'กรุณากรอกข้อความ':''" 
                            :type="valid[component.name+'UserValue'+index].valid === true?'is-danger':''"
                            class="mg-l-2 mw-500 fixed-error-msg"
                        > 
                            <b-input 
                                expanded
                                placeholder="โปรดระบุ"
                                icon-pack="fas"
                                v-model="checkVarDes[component.name+index].des"
                                @keyup.native="checkValidateRequiredArrayDes(component.name,value.label,$event.target.value,index,component.name+'UserValue'+index,true)"
                            >
                            </b-input>
                        </b-field>
                    </div>
                </div>
                <p class="th is-size-7 mg-t-5"  :class="{'has-text-danger':valid[component.name].valid === true}">{{valid[component.name].valid === true?component.validation.errorMsg:''}}</p>
            </div>
            <div v-show="typeof inputFormData[component.name] !== 'undefined' && inputFormData[component.name].length > 0" class="pd-y-5">
                <div class="is-flex" v-for="(inputItem,indexInput) in inputFormData[component.name]" :key="indexInput" >
                    <div >
                        <div  v-for="(value,index) in inputItem.display.value" :key="index" class="field">
                            <div class="is-flex ai-center">
                                <b-checkbox 
                                    v-model="checkModelValue[inputItem.name]"
                                    @change.native="setDataCheckBox(value.label,inputItem.name,index,inputItem.name+'UserValue'+index)"
                                    @input="checkValidateRequiredCheckBox(inputItem.name,inputItem.validation.required),setMatchId(checkModelValue[inputItem.name],value,components,'checkbox'),setTourForm()"
                                    :native-value="{label:value.label,value:value.value,userValue:value.userValue,index:index}"
                                    type="is-dark"
                                >
                                    <p class="th">{{value.label}}</p>
                                </b-checkbox>
                                <b-field 
                                    v-if="value.userValue === true && checkModelValue[inputItem.name].length !== 0 && checkValueCheckBox(value.label,checkModelValue[inputItem.name]) === true" 
                                    :message="valid[inputItem.name+'UserValue'+index].valid === true?'กรุณากรอกข้อความ':''" 
                                    :type="valid[inputItem.name+'UserValue'+index].valid === true?'is-danger':''"
                                    class="mg-l-2 mw-500 fixed-error-msg"
                                > 
                                    <b-input 
                                        expanded
                                        placeholder="โปรดระบุ"
                                        icon-pack="fas"
                                        v-model="checkVarDes[inputItem.name+index].des"
                                        @keyup.native="checkValidateRequiredArrayDes(inputItem.name,value.label,$event.target.value,index,inputItem.name+'UserValue'+index,true)"
                                    >
                                    </b-input>
                                </b-field>
                            </div>
                        </div>
                        <p class="th is-size-7 mg-t-5"  :class="{'has-text-danger':valid[inputItem.name].valid === true}">{{valid[inputItem.name].valid === true?inputItem.validation.errorMsg:''}}</p>
                    </div>
                    <a class="mg-2" @click="delInput(component.name,indexInput)">
                        <b-icon
                            pack="fas"
                            size="is-small"
                            icon="minus-circle"
                            custom-class="mg-x-5 has-text-grey-dark"
                        ></b-icon>  
                    </a>  
                </div>
            </div>
            <div class="pd-y-5" v-if="typeof component.options !== 'undefined' && typeof component.options.usercanadd  !== 'undefined' && component.options.usercanadd === true">
                <a @click="addInput(component,components)" class="button is-small is-outlined" >Add input</a>
            </div>
        </div>
    </div>
</template>
<script>
import  FieldUpload  from "./FieldUpload";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import DatePicker from 'vue2-datepicker'

export default {
    name:'FormInput',
    components:{
        FieldUpload,
        VuePhoneNumberInput,
        DatePicker
    },
    props:[
        'components',
        'component',
        'valid',
        'input',
        'checkModelValue',
        'checkValidate',
        'checkValidateRequired',
        'checkValidateRequiredObject',
        'checkValidateRequiredCheckBox',
        'checkValidateRequiredDes',
        'checkValidateRequiredArrayDes',
        'delInput',
        'addInput',
        'componentsIndex',
        'componentDataIndex', 
        'matchId',
        'inputFormData',
        'checkVarDes',
        'setMatchId',
        'delFile',
        'checkValidatePhoneNumber',
        'dataKpi',
        'dataInputKpi',
        'formUserId',
        'ownedId'
    ],
    data(){
        return {
            phoneNumber:""
        }
    },
    created() {
        this.phoneNumber = ( this.input[this.component.name] !== null &&  typeof this.input[this.component.name] !== 'undefined' &&  typeof this.input[this.component.name].value !== 'undefined')?this.input[this.component.name].value:''
    },
    computed: {
        getCountryDynamic(){
            return this.$store.getters.getCountryDynamic
        },
        getProvinceDynamic(){
            return this.$store.getters.getProvinceDynamic
        },
 
    },
    methods: {
        checkMathId(matchid,displaymatchid){
            if(typeof displaymatchid !== 'undefined' && Object.values(displaymatchid).length > 0 && typeof matchid !== 'undefined'){
                let data = []
                Object.keys(displaymatchid).forEach((key) => {
                   if (displaymatchid[key] === matchid) {
                       data.push(displaymatchid[key])
                   } 
                });
                    
                return matchid === '' || data.length > 0
            }
            return true
        },
        setTourForm(){
            // if(typeof this.$tours['tourForm'] !== 'undefined'){
            //     this.$tours['tourForm'].stop()
            // }
        },
        setDataCheckBox(label,name,indexValid,valid){
           
            let data = this.checkModelValue[name].filter(item => item.label === label)
           
            for (let index = 0; index < this.checkModelValue[name].length; index++) {
                if (label === this.checkModelValue[name][index].label && typeof this.checkVarDes[name+indexValid] !== 'undefined') {
                    this.checkVarDes[name+indexValid].des = null
                    let obj = this.checkVarDes[name+indexValid];
                    obj.des = null; 
                    this.checkVarDes = Object.assign({}, this.checkVarDes, obj);
                }
            }


            if (data.length === 0 && typeof this.valid[valid] !=='undefined') {
                let obj = this.valid;
                obj[valid]['valid'] = false; 
                this.valid = Object.assign({}, this.valid, obj);
            }
        },
        checkValueCheckBox(label,value){
            let data = value.filter(item => item.label === label)
            if (data.length > 0) {
                return  true
            }else{
                return  false
            }
        },
        getSelectValue(choice,value){
            if(choice === 'custom' || choice !== 'country' || choice !== 'province'){
                return value
            }else if(choice === 'country'){
                return this.getCountryDynamic
            }else if(choice === 'province'){
                return  this.getProvinceDynamic
            }else{
                return []
            }
        },
        clearRadio(input,name,value){
            input.des = null
            value.map((item,index)=>{
                if (typeof this.valid[name+'UserValue'+index] !== 'undefined') {
                    this.valid[name+'UserValue'+index].valid = false
                }
            })
        },
        updateNumberPhone(payload){
            payload['value']= (payload.phoneNumber !== null)?payload.phoneNumber.replace(/\s/g, ''):''
            this.input[this.component.name] = payload
            this.checkValidatePhoneNumber(this.valid[this.component.name].name,this.valid[this.component.name].validation.required)
        },
    }
}
</script>
<style scoped>
    .mw-500{
        min-width: 500px!important;
    }
    .vue-phone-number-input .input-phone-number input {
        margin-left: 0px!important;
    }
    .des-dynamic th{
        color: #565656!important;
    }

</style>
